export class ValidateRegistrationCredentialsDto {
  email: string;
  password: string;
}
